/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiFinalRiskLevel } from './InternalApiFinalRiskLevel';
import {
    InternalApiFinalRiskLevelFromJSON,
    InternalApiFinalRiskLevelFromJSONTyped,
    InternalApiFinalRiskLevelToJSON,
    InternalApiFinalRiskLevelToJSONTyped,
} from './InternalApiFinalRiskLevel';

/**
 * Risk override
 * @export
 * @interface InternalApiFinalRiskOverride
 */
export interface InternalApiFinalRiskOverride {
    /**
     * 
     * @type {number}
     * @memberof InternalApiFinalRiskOverride
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiFinalRiskOverride
     */
    reasonHandle: string;
    /**
     * 
     * @type {InternalApiFinalRiskLevel}
     * @memberof InternalApiFinalRiskOverride
     */
    level: InternalApiFinalRiskLevel;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiFinalRiskOverride
     */
    endTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof InternalApiFinalRiskOverride
     */
    comment: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiFinalRiskOverride
     */
    userId: number;
}



/**
 * Check if a given object implements the InternalApiFinalRiskOverride interface.
 */
export function instanceOfInternalApiFinalRiskOverride(value: object): value is InternalApiFinalRiskOverride {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('reasonHandle' in value) || value['reasonHandle'] === undefined) return false;
    if (!('level' in value) || value['level'] === undefined) return false;
    if (!('comment' in value) || value['comment'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function InternalApiFinalRiskOverrideFromJSON(json: any): InternalApiFinalRiskOverride {
    return InternalApiFinalRiskOverrideFromJSONTyped(json, false);
}

export function InternalApiFinalRiskOverrideFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiFinalRiskOverride {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'reasonHandle': json['reasonHandle'],
        'level': InternalApiFinalRiskLevelFromJSON(json['level']),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
        'comment': json['comment'],
        'userId': json['userId'],
    };
}

export function InternalApiFinalRiskOverrideToJSON(json: any): InternalApiFinalRiskOverride {
    return InternalApiFinalRiskOverrideToJSONTyped(json, false);
}

export function InternalApiFinalRiskOverrideToJSONTyped(value?: InternalApiFinalRiskOverride | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'reasonHandle': value['reasonHandle'],
        'level': InternalApiFinalRiskLevelToJSON(value['level']),
        'endTime': value['endTime'] == null ? value['endTime'] : value['endTime'].toISOString(),
        'comment': value['comment'],
        'userId': value['userId'],
    };
}

